import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import { Text } from 'foundations-components/components/Text';
import { View } from 'foundations-components/components/View';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { TRACKING_SOURCES, trackTooltipInteraction } from '../../../utils/tracking';
import { jsx as _jsx } from "react/jsx-runtime";
export function HubSpotCreditsWithTooltip({
  count
}) {
  return /*#__PURE__*/_jsx(Tooltip, {
    placement: "bottom",
    maxInlineSize: "315px",
    onOpenChange: e => {
      if (e.currentTarget.value) {
        trackTooltipInteraction({
          action: 'hovered',
          name: 'included-hubspot-credits-tooltip',
          value: `${count} HubSpot Credits`,
          trackingSource: TRACKING_SOURCES.MERCH_CARD
        });
      }
    },
    headingText: /*#__PURE__*/_jsx(Text, {
      typography: "heading-300",
      color: "text-core-on-fill-default",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "publicPricingPage.merchCard.credits.hubspotCreditsTooltipHeading"
      })
    }),
    title: /*#__PURE__*/_jsx(View, {
      children: /*#__PURE__*/_jsx(Text, {
        typography: "body-100",
        color: "text-core-on-fill-default",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "publicPricingPage.merchCard.credits.hubspotCreditsTooltipText"
        })
      })
    }),
    children: /*#__PURE__*/_jsx(View, {
      cursor: "help",
      children: /*#__PURE__*/_jsx(Text, {
        typography: "body-100",
        children: /*#__PURE__*/_jsx(FormattedReactMessage, {
          message: "publicPricingPage.merchCard.credits.hubspotCredits",
          options: {
            count: count.toLocaleString()
          }
        })
      })
    })
  });
}